import { render, staticRenderFns } from "./menu-icon-upload.vue?vue&type=template&id=0a11b51a&scoped=true&"
import script from "./menu-icon-upload.vue?vue&type=script&lang=js&"
export * from "./menu-icon-upload.vue?vue&type=script&lang=js&"
import style0 from "./menu-icon-upload.vue?vue&type=style&index=0&id=0a11b51a&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11b51a",
  null
  
)

export default component.exports